var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddTimerIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    fill: "#57B661"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8402_3557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4987 7.66683C4.4987 7.79944 4.55138 7.92661 4.64514 8.02038C4.73891 8.11415 4.86609 8.16683 4.9987 8.16683C5.13131 8.16683 5.25848 8.11415 5.35225 8.02038C5.44602 7.92661 5.4987 7.79944 5.4987 7.66683V5.50016H7.66536C7.79797 5.50016 7.92515 5.44748 8.01892 5.35372C8.11269 5.25995 8.16536 5.13277 8.16536 5.00016C8.16536 4.86755 8.11269 4.74038 8.01892 4.64661C7.92515 4.55284 7.79797 4.50016 7.66536 4.50016H5.4987V2.3335C5.4987 2.20089 5.44602 2.07371 5.35225 1.97994C5.25848 1.88617 5.13131 1.8335 4.9987 1.8335C4.86609 1.8335 4.73891 1.88617 4.64514 1.97994C4.55138 2.07371 4.4987 2.20089 4.4987 2.3335V4.50016H2.33203C2.19942 4.50016 2.07225 4.55284 1.97848 4.64661C1.88471 4.74038 1.83203 4.86755 1.83203 5.00016C1.83203 5.13277 1.88471 5.25995 1.97848 5.35372C2.07225 5.44748 2.19942 5.50016 2.33203 5.50016H4.4987V7.66683Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8402_3557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTimerIcon);
export default __webpack_public_path__ + "static/media/addTimerIcon.4236f93bd5cee540dfd2d5561d797799.svg";
export { ForwardRef as ReactComponent };